export const SET_CAFE_DISCOUNTS_RESPONSE = "SET_CAFE_DISCOUNTS_RESPONSE";
export const SET_CAFE_TRANSACTION_RESPONSE = "SET_CAFE_TRANSACTION_RESPONSE";
export const SET_CAFE_USAGE = "SET_CAFE_USAGE";
export const SET_CAFE_MENU = "SET_CAFE_MENU";